import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../components/common-modal/CommonModal';
import ContactForm from '../contact-form/ContactForm';

import scss from './ContactModal.module.scss';

function ContactModal({ isOpen, onClose }) {
  const { t } = useTranslation('contact');

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName={scss.wrapper} isAnimated>
      <h3 className={scss.title}>{t('contactUs')}</h3>
      <ContactForm onClose={onClose} />
    </CommonModal>
  );
}

export default ContactModal;
